import React, { useEffect} from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useForm, useFieldArray } from "react-hook-form";
import { useDispatch,useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { clearMsg } from "src/Actions/Admin/adminActions";
import { StoreNewSpecialities } from "src/Thunk/adminThunks";
const MySwal = withReactContent(Swal);
const AddNewSpecialities = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { msg, error } = useSelector((state) => state.admin);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      specialities: [{ name: "", clinic_fare:"", online_fare: "", specialityIcon:"" }],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "specialities",
  });
  useEffect(() => {
    if (msg) {
      MySwal.fire({
        icon: "success",
        title: msg,
      });
      setTimeout(() => {
       dispatch(clearMsg())
      },1200)
      reset();
      navigate('/SpecialityList')
    }
    if (error) {
      MySwal.fire({
        icon: "error",
        title: error,
      });
    }
  }, [msg, error]);

  const handleSave = (data) => {
    const formData = new FormData();
    const Icons = data.specialities.map((item) => {
      return item.specialityIcon[0];
    })
    Icons.forEach((file) => {
      formData.append(`specialityIcon`, file);
    });
    formData.append('specialities', JSON.stringify(data.specialities));
    dispatch(StoreNewSpecialities(formData));
  };

  const handleAddField = () => {
    append({ name: "", clinic_fare:"", online_fare: "", specialityIcon:"" });
  };

  const handleRemoveField = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 text-info">ADD NEW SPECIALITIES</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="breadcrumb-item active text-info">
                        Add New Specialities
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="card custom-shadow rounded-lg border my-2">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit(handleSave)}>
                      {fields.map((field, index) => (
                        <div className="row mb-3" key={field.id}>
                          <Form.Group className="col-lg-2 mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Name"
                              {...register(`specialities.${index}.name`, {
                                required: "Speciality name required",
                              })}
                            />
                            {errors.specialities?.[index]?.name && (
                              <p className="text-danger">
                                {errors.specialities[index].name.message}
                              </p>
                            )}
                          </Form.Group>

                          <Form.Group className="col-lg-2 mb-3">
                            <Form.Label>Clinic Fare</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter clinic fare"
                              {...register(
                                `specialities.${index}.clinic_fare`,
                                {
                                  required: "clinic fare required",
                                }
                              )}
                            />
                            {errors.specialities?.[index]
                              ?.clinic_fare && (
                              <p className="text-danger">
                                {
                                  errors.specialities[index]
                                    .clinic_fare.message
                                }
                              </p>
                            )}
                          </Form.Group>
                          <Form.Group className="col-lg-2 mb-3">
                            <Form.Label>Online Fare</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter online fare"
                              {...register(
                                `specialities.${index}.online_fare`,
                                {
                                  required: "online fare required ",
                                }
                              )}
                            />
                            {errors.specialities?.[index]
                              ?.online_fare && (
                              <p className="text-danger">
                                {
                                  errors.specialities[index]
                                    .online_fare.message
                                }
                              </p>
                            )}
                          </Form.Group>
                          <Form.Group className="col-lg-3 mb-3">
                            <Form.Label>Speciality Icon</Form.Label>
                            <Form.Control
                              type="file"
                              placeholder="Enter base fare"
                              {...register(
                                `specialities.${index}.specialityIcon`,
                                {
                                  required: "speciality image required",
                                }
                              )}
                            />
                            {errors.specialities?.[index]
                              ?.specialityIcon && (
                              <p className="text-danger">
                                {
                                  errors.specialities[index]
                                    .specialityIcon.message
                                }
                              </p>
                            )}
                          </Form.Group>

                          <div className="col-lg-3 d-flex align-items-center">
                            {index === 0 && (
                              <Button
                                variant="outline-primary"
                                className="btn mt-3"
                                onClick={handleAddField}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                            )}
                            {index > 0 && (
                              <Button
                                variant="outline-danger"
                                className="btn mt-3"
                                onClick={() => handleRemoveField(index)}
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </Button>
                            )}
                          </div>
                        </div>
                      ))}

                      <div className="text-end">
                        <Button
                          variant="outline-secondary"
                          className="btn m-2"
                          as={Link}
                          to="/dashboard"
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="info"
                          className="btn btn-primary text-white m-2"
                          type="submit"
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewSpecialities;
